import React from 'react';
function SVGIcon({ id, customClass, customStyle, size, iconName, fillColor = 'var(--base-600, var(--v-600, #333))', onClick, dataCy, viewBox, width, height, eventStopPropagation = true, disabled = false, usingFlex = true, onMouseDown, ariaHidden }) {
    const _width = width || size;
    const _height = height || size;
    // eslint-disable-next-line no-nested-ternary
    const cursorClass = onClick
        ? disabled
            ? 'cursor-not-allowed'
            : 'cursor-pointer'
        : '';
    return (React.createElement("span", { id: id || 'svg-' + iconName, className: `${usingFlex ? 'flex' : ''} ${customClass ? customClass : ''} ${cursorClass}`, style: customStyle, "data-cy": dataCy, onClick: (e) => {
            onClick && !disabled && eventStopPropagation
                ? (e.stopPropagation(), onClick(e))
                : onClick && !disabled && onClick(e);
        }, onMouseDown: (e) => {
            onMouseDown && !disabled && eventStopPropagation
                ? (e.stopPropagation(), onMouseDown(e))
                : onMouseDown && !disabled && onMouseDown(e);
        }, "aria-hidden": ariaHidden },
        React.createElement("svg", { width: `${_width}px`, height: `${_height}px`, viewBox: viewBox ? viewBox : '0 0 24 24', fill: fillColor },
            React.createElement("use", { xlinkHref: `/assets/img/sprite.svg#${iconName}`, href: `/assets/img/sprite.svg#${iconName}` }))));
}
export default SVGIcon;
